// @flow 

import Box from "@mui/material/Box";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import EditableMUICellValidation
	from "../../../components/mui/grids/editableMUICellValidation/editableMUICellValidation";
import EditableMuiDataGridCustomFields
	from "../../../components/mui/grids/editableMUIDataGridCustomFields/editableMUIDataGridCustomFields";
import { API } from "../../../helpers/constants";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import useUserData from "../../../hooks/user/useUserData";
import { REGISTRATIONS } from "../locales/namespaces";

type Props = {};

const WorkersGridField = (props: Props) => {
	const { params, workers, getRestrictions, formik } = props
	const { token } = useUserData();
	const { t } = useTranslation(REGISTRATIONS)
	const [loading, setLoading] = useState(false)
	const [workersData, setWorkersData] = useState(Array.isArray(workers) ? workers : [])
	const searchWorkers = (evt) => {
		setLoading(true)
		axios({
			method: 'post',
			data: { 'query': evt.target.value, isForeman: 0 },
			url: `${API}/en/fts/project/user/search`,
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
		}).then((response) => {
			if (response.data.result.length > 0) {
				setWorkersData(response.data.result)
			}
			setLoading(false)
		}).catch((error) => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
			setLoading(false)
		})
	}
	
	const availableWorkers = useMemo(() => {
		const usedUserIds = formik.values.projectWorks //παίρνω το projectWorks από το Formik
		.filter((row) => row.id !== params.id && !!row.UserId?.id) //φιλτράρω και κρατάω όλες τις σειρές των χρηστών εκτός από αυτή που επέλεξα τώρα.
		.map((row) => typeof row.UserId === 'object' ? row.UserId.id : row.UserId); // και από αυτές τις σειρές παίρνω απο την κάθε μία μόνο το id.
		return workersData.filter(worker => !usedUserIds.includes(worker.id)); //Από τη λίστα workersData, φιλτράρουμε εκείνους που δεν έχουν χρησιμοποιηθεί ακόμα στο projectWorks.
	}, [formik.values.projectWorks, params.id, workersData])
	
	return (
		<Box
			sx={{
				display: 'flex',
				width: '100%',
				position: 'relative'
			}}
		>
			{/* Μπήκε εδώ το validation επειδή δε δούλευε σωστά το tooltip αν περικλύσεις όλο το custom autocomplete. */}
			<EditableMUICellValidation {...params}>
				<Box sx={{ width: 0, height: 0, bottom: 0, left: 40, position: 'absolute' }}/>
			</EditableMUICellValidation>
			<EditableMuiDataGridCustomFields
				type="customAutocomplete"
				params={params}
				name="UserId"
				labelKey={'Description'}
				options={availableWorkers}
				otherInputParams={{
					otherprops: {
						getOptionKey: (option) => (option.id),
						disableClearable: true,
						selectOnFocus: true,
						handleHomeEndKeys: true,
						loading: loading,
						sx: {width: '100%'}
					}
				}}
				onChangeInput={(event) => searchWorkers(event)}
				onChange={({ newValue, apiRef, params }) => {
					if (newValue?.id) {
						const existingUsers = formik.values.projectWorks.map((i) => (i.UserId?.id))?.filter(f => f)
						getRestrictions([...existingUsers, newValue.id])
					}
				}}
			/>
		</Box>
	);
};

export default WorkersGridField